export const ATTENDANCE_OPTIONS = [
  { value: "likely", label: "Going - Likely" },
  { value: "maybe", label: "Tentative - Will try" },
  { value: "not_coming", label: "Not going - Can't make it" },
];

export function attendanceStatus(rsvp) {
  return rsvp?.attendance_status || "likely";
}

export function isLikelyComing(rsvp) {
  return attendanceStatus(rsvp) === "likely";
}

export function isTentativeOrDeclined(rsvp) {
  const s = attendanceStatus(rsvp);
  return s === "maybe" || s === "not_coming";
}

export function attendanceLabel(status) {
  return ATTENDANCE_OPTIONS.find((o) => o.value === status)?.label || "Likely to come";
}

export function eventRequiresInvite(event) {
  if (!event) return false;
  if (event.requires_invite) return true;
  if (event.access === "invite-only") return true;
  return event.pricing?.type === "paid-self-managed";
}
